/**
 * Enterprise registration constants
 * Shared patterns for facility name validation and detection
 */

// Pattern for VALIDATING new facility names: 3-letter code + 1-2 digits, no leading zero (e.g., YYZ1, YYZ12)
export const FACILITY_NAME_PATTERN = /^[A-Z]{3}[1-9][0-9]?$/i;

// Pattern for validating just the 3-letter facility code portion
export const FACILITY_CODE_PATTERN = /^[A-Z]{3}$/i;

// Pattern for DETECTING existing facilities: 3-letter code + any digits (relaxed for legacy data)
export const FACILITY_DETECTION_PATTERN = /^[A-Z]{3}[0-9]+$/i;

// Debounce delay for airport code validation (ms)
export const AIRPORT_CODE_DEBOUNCE_MS = 500;

// Tree depth indentation multiplier (spacing units)
export const TREE_DEPTH_INDENT_MULTIPLIER = 3;
